module.exports = __webpack_public_path__ + "media/images/smart_phone/item/lt-9199587ad1a67ac8860c49c1146e54b9.gif";